import { render, staticRenderFns } from "./point-table.vue?vue&type=template&id=90e2eae4&scoped=true&"
import script from "./point-table.vue?vue&type=script&lang=js&"
export * from "./point-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90e2eae4",
  null
  
)

export default component.exports